import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from './bpmn-modeler-state.selector';

const getBpmnProcessXml = (state: State): any => state.bpmnXml;

export const selectBpmnProcessXml: MemoizedSelector<
  object,
  string
  > = createSelector(selectBpmnModelerState, getBpmnProcessXml);
